// extracted by mini-css-extract-plugin
module.exports = {"grid":"credit-grid_grid__3Ic2l","minWidth":"credit-grid_minWidth__pt_CO"};